(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["portrait-configurator"] && !Shopify.designMode) return;
  try {
    
function initPortraits(scope){
  scope.querySelectorAll('[data-portrait-config]').forEach(root=>{
    if(root.dataset.ready)return;
    root.dataset.ready='true';
    const variants=JSON.parse(root.querySelector('[data-variants]').textContent);
    const form=root.querySelector('form');
    let submitting=false;
    let pendingRequest=null;
    const language=(root.dataset.locale||'en').split('-')[0];
    const messages={
      en:{formats:'JPG, PNG, WebP, HEIC or HEIF, up to 10 MB per photo.',type:'Please choose a JPG, PNG, WebP, HEIC or HEIF photo.',size:'This photo is too large. Maximum: 10 MB per photo.',empty:'This file is empty. Please choose the original photo again.',selected:'Selected; uploaded when you add the portrait to your cart.',preview:'Selected; your browser cannot show a preview of this format. The original photo will be uploaded.',missing:'Please choose at least one photo or select that you will send photos later.',uploading:'Uploading your photos and saving your portrait. Please keep this page open…',failed:'Your portrait could not be added. Your photos and details are still selected. Please try again.',uncertain:'We could not confirm the upload. Please check your cart before trying again, or contact shop@nellycastro.com. Your selections remain on this page.',incomplete:'Some photos were not confirmed by Shopify. Please do not check out yet. Contact shop@nellycastro.com so we can help.',done:'Photos and configuration saved. Opening your cart…'},
      de:{formats:'JPG, PNG, WebP, HEIC oder HEIF, maximal 10 MB pro Foto.',type:'Bitte wähle ein Foto als JPG, PNG, WebP, HEIC oder HEIF.',size:'Dieses Foto ist zu groß. Maximal 10 MB pro Foto.',empty:'Diese Datei ist leer. Bitte wähle das Originalfoto erneut aus.',selected:'Ausgewählt; wird beim Hinzufügen zum Warenkorb hochgeladen.',preview:'Ausgewählt; dein Browser kann dieses Format nicht als Vorschau anzeigen. Das Originalfoto wird hochgeladen.',missing:'Bitte wähle mindestens ein Foto aus oder markiere, dass du Fotos nachreichst.',uploading:'Deine Fotos und deine Konfiguration werden übertragen. Bitte lasse diese Seite geöffnet…',failed:'Dein Portrait konnte nicht hinzugefügt werden. Deine Fotos und Angaben bleiben ausgewählt. Bitte versuche es erneut.',uncertain:'Wir konnten den Upload nicht bestätigen. Bitte prüfe vor einem erneuten Versuch deinen Warenkorb oder kontaktiere shop@nellycastro.com. Deine Auswahl bleibt auf dieser Seite erhalten.',incomplete:'Shopify hat nicht alle Fotos bestätigt. Bitte schließe den Kauf noch nicht ab und kontaktiere shop@nellycastro.com, damit wir dir helfen können.',done:'Fotos und Konfiguration gespeichert. Dein Warenkorb wird geöffnet…'},
      es:{formats:'JPG, PNG, WebP, HEIC o HEIF, máximo 10 MB por foto.',type:'Elige una foto en formato JPG, PNG, WebP, HEIC o HEIF.',size:'Esta foto es demasiado grande. Máximo: 10 MB por foto.',empty:'Este archivo está vacío. Vuelve a seleccionar la foto original.',selected:'Seleccionada; se subirá al añadir el retrato a la cesta.',preview:'Seleccionada; tu navegador no puede mostrar una vista previa de este formato. Se subirá la foto original.',missing:'Selecciona al menos una foto o indica que las enviarás más adelante.',uploading:'Estamos subiendo tus fotos y guardando tu retrato. Mantén esta página abierta…',failed:'No hemos podido añadir tu retrato. Tus fotos y datos siguen seleccionados. Vuelve a intentarlo.',uncertain:'No hemos podido confirmar la subida. Comprueba tu cesta antes de volver a intentarlo o escribe a shop@nellycastro.com. Tu selección sigue en esta página.',incomplete:'Shopify no ha confirmado todas las fotos. No finalices la compra todavía y escribe a shop@nellycastro.com para que podamos ayudarte.',done:'Fotos y configuración guardadas. Abriendo tu cesta…'}
    };
    const text=messages[language]||messages.en;
    const help=root.querySelector('[data-photo-help]');
    help.textContent=help.textContent.replace(/\([^)]*(?:JPG|PNG|WebP)[^)]*\)/, '('+text.formats+')');
    const photoCount=root.querySelector('[data-photo-count]');
    const uploadGuide={en:'Choose one photo per field. Use “Add another photo” for the next image. Selecting a new file in the same field replaces the previous one.',de:'Wähle pro Feld ein Foto. Nutze für das nächste Bild „Weiteres Foto hinzufügen“. Eine neue Auswahl im selben Feld ersetzt das vorherige Foto.',es:'Elige una foto por campo. Usa «Añadir otra foto» para la siguiente. Si seleccionas otro archivo en el mismo campo, sustituirá al anterior.'};
    help.textContent+=' '+(uploadGuide[language]||uploadGuide.en);
    const status=root.querySelector('[data-upload-status]');
    const uploadError=root.querySelector('[data-upload-error]');
    const submitButton=root.querySelector('[data-submit]');
    const originalButtonText=submitButton.textContent;

    const process=root.querySelector('[data-process]');
    const agreements=root.querySelector('[data-agreements]');
    let processOpened=false;
    const readNotice=root.querySelector('[data-read-notice]');
    const agreementLock=root.querySelector('[data-agreement-lock]');
    agreementLock.addEventListener('click',event=>{
      if(processOpened)return;
      readNotice.hidden=false;
      const anchor=agreementLock.getBoundingClientRect();
      const x=event.detail?event.clientX:anchor.left+20;
      const y=event.detail?event.clientY:anchor.top+20;
      const bounds=readNotice.getBoundingClientRect();
      readNotice.style.left=Math.max(12,Math.min(x+12,window.innerWidth-bounds.width-12))+'px';
      readNotice.style.top=Math.max(12,Math.min(y+12,window.innerHeight-bounds.height-12))+'px';
    });
    document.addEventListener('click',event=>{
      if(!agreementLock.contains(event.target))readNotice.hidden=true;
    });
    document.addEventListener('keydown',event=>{
      if(event.key==='Escape')readNotice.hidden=true;
    });
    window.addEventListener('scroll',()=>readNotice.hidden=true,{passive:true});
    const examples=Array.from(root.querySelectorAll('[data-example]'));
    const buttons=Array.from(root.querySelectorAll('[data-example-button]'));
    const rules=JSON.parse(root.querySelector('[data-example-rules]').textContent);
    const showExample=index=>{
      examples.forEach((example,i)=>example.hidden=i!==index);
      buttons.forEach((button,i)=>button.setAttribute('aria-pressed',String(i===index)));
    };
    buttons.forEach(button=>button.addEventListener('click',()=>showExample(Number(button.dataset.exampleButton))));
    const photos=Array.from(root.querySelectorAll('[data-photo]'));
    const error=root.querySelector('[data-photo-error]');
    const photoProblem=file=>{
      if(!file.size)return text.empty;
      const type=(file.type||'').toLowerCase();
      const extension=(file.name.split('.').pop()||'').toLowerCase();
      const mimeAllowed=['image/jpeg','image/png','image/webp','image/heic','image/heif','image/heic-sequence','image/heif-sequence'].includes(type);
      const extensionAllowed=['jpg','jpeg','png','webp','heic','heif'].includes(extension);
      if(!mimeAllowed&&!(extensionAllowed&&(!type||type==='application/octet-stream')))return text.type;
      if(file.size>10*1024*1024)return text.size;
      return '';
    };
    const validatePhotos=()=>{
      photos.forEach(input=>{
        input.required=false;
        input.setCustomValidity(input.files[0]?photoProblem(input.files[0]):'');
      });
      const count=photos.filter(input=>input.files.length>0&&!photoProblem(input.files[0])).length;
      photoCount.textContent=language==='de'?count+' Foto(s) ausgewählt':language==='es'?count+' foto(s) seleccionada(s)':count+' photo(s) selected';
      const selected=count>0;
      if(!root.querySelector('[data-later]').checked&&!selected)photos[0].setCustomValidity(photos[0].files[0]?photoProblem(photos[0].files[0]):text.missing);
    };
    photos.forEach(input=>{
      const row=input.closest('[data-photo-row]');
      const thumbnail=row.querySelector('[data-photo-preview]');
      const state=row.querySelector('[data-photo-state]');
      const remove=row.querySelector('[data-remove-photo]');
      const clearPreview=()=>{
        if(thumbnail.dataset.objectUrl)URL.revokeObjectURL(thumbnail.dataset.objectUrl);
        delete thumbnail.dataset.objectUrl;
        thumbnail.removeAttribute('src');
        thumbnail.hidden=true;
        remove.hidden=true;
        state.textContent='';
      };
      input.addEventListener('change',()=>{
        clearPreview();
        error.textContent='';
        const file=input.files[0];
        if(file){
          const problem=photoProblem(file);
          remove.hidden=false;
          if(problem){error.textContent=file.name+': '+problem;state.textContent=problem;}
          else{
            state.textContent=file.name+' — '+text.selected;
            thumbnail.onload=()=>{thumbnail.hidden=false;};
            thumbnail.onerror=()=>{thumbnail.hidden=true;state.textContent=file.name+' — '+text.preview;};
            thumbnail.dataset.objectUrl=URL.createObjectURL(file);
            thumbnail.src=thumbnail.dataset.objectUrl;
          }
        }
        validatePhotos();
      });
      remove.addEventListener('click',()=>{
        input.value='';
        clearPreview();
        error.textContent='';
        validatePhotos();
      });
    });
    root.querySelector('[data-later]').addEventListener('change',validatePhotos);
    root.querySelector('[data-more-photos]').addEventListener('click',event=>{
      const row=root.querySelector('[data-photo-row][hidden]');
      if(row)row.hidden=false;
      event.currentTarget.hidden=!root.querySelector('[data-photo-row][hidden]');
    });
    let lastExampleKey='';
    const update=()=>{
      const petPortrait=root.dataset.petPortrait==='true';
      const people=petPortrait?0:Number(root.querySelector('[data-people]').value);
      const pets=Number(root.querySelector('[data-pets]').value);
      const objects=petPortrait?0:Number(root.querySelector('[data-objects]').value);
      const background=!petPortrait&&root.querySelector('[data-background]').value==='Yes';
      const price=petPortrait?9500+(pets-1)*3000:14500+(people-1)*4500+(pets+objects)*3000+(background?7500:0);
      const variant=variants.find(v=>v.price===price);
      root.querySelector('[data-total]').textContent=new Intl.NumberFormat(root.dataset.locale,{style:'currency',currency:root.dataset.currency}).format(price/100);
      root.querySelector('[data-variant]').value=variant?variant.id:'';
      root.querySelector('[data-submit]').disabled=submitting||!processOpened||!variant||!variant.available||!Array.from(root.querySelectorAll('[data-agreement]')).every(input=>input.checked);
      const exampleKey=people+'-'+pets;
      if(exampleKey!==lastExampleKey){
        lastExampleKey=exampleKey;
        let bestIndex=0;
        let bestScore=Infinity;
        rules.forEach((rule,index)=>{
          const score=Math.abs(rule.people-people)*10+Math.abs(rule.pets-pets);
          if(score<bestScore){bestScore=score;bestIndex=index;}
        });
        showExample(bestIndex);
      }
    };
    process.addEventListener('toggle',()=>{
      if(process.open){
        processOpened=true;
        agreements.disabled=false;
        readNotice.hidden=true;
        agreementLock.hidden=true;
        agreements.removeAttribute('aria-describedby');
        update();
      }
    });
    const cartRoot=window.Shopify&&window.Shopify.routes?window.Shopify.routes.root:'/';
    const readCart=async()=>{
      const response=await fetch(cartRoot+'cart.js',{credentials:'same-origin',cache:'no-store'});
      if(!response.ok)throw new Error('cart');
      return response.json();
    };
    const matchingItem=cart=>(cart.items||[]).find(item=>item.properties&&item.properties._portrait_request===pendingRequest.id);
    const completeItem=item=>item&&pendingRequest.expected.every(([key,value])=>{
      const actual=item.properties&&item.properties[key];
      return value===null?typeof actual==='string'&&actual.includes('/uploads/'):String(actual)===value;
    });
    const fail=message=>{
      status.textContent='';
      uploadError.textContent=message;
      uploadError.hidden=false;
      uploadError.focus();
    };
    const finish=()=>{
      status.textContent=text.done;
      window.location.assign(cartRoot+'cart');
    };
    form.addEventListener('submit',async event=>{
      event.preventDefault();
      event.stopImmediatePropagation();
      if(submitting)return;
      validatePhotos();
      if(!form.reportValidity())return;
      submitting=true;
      update();
      uploadError.hidden=true;
      status.textContent=text.uploading;
      form.setAttribute('aria-busy','true');
      submitButton.textContent=text.uploading;
      try{
        if(pendingRequest){
          let cart;
          try{cart=await readCart();}catch{fail(text.uncertain);return;}
          const existing=matchingItem(cart);
          if(existing){if(completeItem(existing))finish();else fail(text.incomplete);return;}
          fail(text.uncertain);
          return;
        }
        const data=new FormData(form);
        const expected=[];
        data.set('properties[Photos uploaded]',String(photos.filter(input=>input.files.length>0&&!photoProblem(input.files[0])).length));
        for(const [name,value] of Array.from(data.entries())){
          const property=name.match(/^properties\[(.+)\]$/);
          if(value instanceof File){
            if(!value.size){data.delete(name);continue;}
            if(property)expected.push([property[1],null]);
          }else if(property&&value!=='')expected.push([property[1],value]);
        }
        pendingRequest={id:typeof crypto.randomUUID==='function'?crypto.randomUUID():Date.now()+'-'+Math.random().toString(36).slice(2),expected};
        data.set('properties[_portrait_request]',pendingRequest.id);
        let response;
        try{response=await fetch(cartRoot+'cart/add.js',{method:'POST',credentials:'same-origin',body:data});}
        catch{
          try{
            const existing=matchingItem(await readCart());
            if(completeItem(existing)){finish();return;}
            fail(existing?text.incomplete:text.uncertain);
          }catch{fail(text.uncertain);}
          return;
        }
        if(!response.ok){
          if(response.status>=400&&response.status<500){pendingRequest=null;fail(text.failed);}
          else fail(text.uncertain);
          return;
        }
        const existing=matchingItem(await readCart());
        if(!completeItem(existing)){fail(text.incomplete);return;}
        finish();
      }catch{fail(text.uncertain);}
      finally{
        submitting=false;
        form.removeAttribute('aria-busy');
        submitButton.textContent=originalButtonText;
        update();
      }
    },true);
    form.addEventListener('change',update);
    update();
    validatePhotos();
  });
}
initPortraits(document);
document.addEventListener('shopify:section:load',event=>initPortraits(event.target));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-reviews"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('nelly-review-form')) {
    customElements.define('nelly-review-form', class extends HTMLElement {
      connectedCallback() {
        this.abort?.abort();
        this.abort = new AbortController();
        const frame = this.querySelector('iframe');
        const details = this.querySelector('details');
        if (!frame || !details) return;
        const target = new URL(frame.dataset.src, window.location.href);
        if (target.protocol !== 'https:') return;
        const load = () => {
          if (details.open && !frame.hasAttribute('src')) frame.src = target.href;
        };
        details.addEventListener('toggle', load, { signal: this.abort.signal });
        window.addEventListener('message', event => {
          if (event.source !== frame.contentWindow || event.origin !== target.origin) return;
          if (event.data?.type !== 'nelly-review-height' || !Number.isFinite(event.data.height)) return;
          frame.style.height = Math.min(5000, Math.max(120, event.data.height + 12)) + 'px';
        }, { signal: this.abort.signal });
        load();
      }
      disconnectedCallback() { this.abort?.abort(); }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
